import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import {
  formatTimeCategoriesByRange,
  getAiSuggestionsUsageWithTotalMessagesTooltipFormatter,
  mapIdsToLabels,
} from './chartUtils';

const OrganizationChatterManualVsAiByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(() => {
    const chartSeries = (data?.series || []).flatMap(item => {
      const chatterName = mapIdsToLabels([item.chatterId], chatterLabelMap)[0];

      const percentageSeries = (item.aiMessageCount || []).map((aiCount, index) => {
        const nextAiCount = Number(aiCount || 0);
        const manualCount = Number(item.manualMessageCount?.[index] || 0);
        const totalCount = nextAiCount + manualCount;

        if (!totalCount) {
          return 0;
        }

        return (nextAiCount / totalCount) * 100;
      });

      return percentageSeries.length
        ? [
            {
              name: chatterName,
              data: percentageSeries,
              totalMessages: (item.aiMessageCount || []).map(
                (aiCount, index) => Number(aiCount || 0) + Number(item.manualMessageCount?.[index] || 0),
              ),
            },
          ]
        : [];
    });

    return {
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: chartSeries,
      tooltipFormatter: getAiSuggestionsUsageWithTotalMessagesTooltipFormatter(),
    };
  }, [data, chatterLabelMap, dateRange]);

  return (
    <OrganizationAnalyticsLineChart
      title="AI Suggestions Usage Over Time"
      subtitle="AI suggestion usage percentage trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load AI suggestions usage over time."
      valueType="percent"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterManualVsAiByTimeChart;
